import React from 'react';

export function StyledClockIcon({
  height = '14',
  width = '14',
  color = 'var(--color-gray-80)',
}: {
  color?: string;
  height?: string;
  width?: string;
}): JSX.Element {
  return (
    <svg fill='currentColor' height={height} viewBox='0 0 20 20' width={width} xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_2269_8232)'>
        <path
          clipRule='evenodd'
          d='M10 1.42857C5.26613 1.42857 1.42857 5.26613 1.42857 10C1.42857 14.7339 5.26613 18.5714 10 18.5714C14.7339 18.5714 18.5714 14.7339 18.5714 10C18.5714 5.26613 14.7339 1.42857 10 1.42857ZM0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10ZM10 5.71429C10.3945 5.71429 10.7143 6.03408 10.7143 6.42857V9.73554L14.1706 13.7634C14.4275 14.0628 14.3931 14.5137 14.0937 14.7706C13.7943 15.0275 13.3434 14.9931 13.0865 14.6937L9.45793 10.4652C9.34681 10.3357 9.28572 10.1706 9.28572 10V6.42857C9.28572 6.03408 9.60551 5.71429 10 5.71429Z'
          fill={color ?? 'inherit'}
          fillRule='evenodd'
        />
      </g>
      <defs>
        <clipPath id='clip0_2269_8232'>
          <rect fill='white' height='20' width='20' />
        </clipPath>
      </defs>
    </svg>
  );
}
